"use client";

import { useMemo, type ReactNode } from "react";
import type { OddsLiveClient } from "@/lib/odds-screen/live/client";
import { WhalesColumnShown, WhalesGateContext, type WhalesGate } from "@/hooks/use-whales-gate";
import { useWhalesUpsell } from "./whales-upsell";

export function WhalesGateProvider({ diamond, client, columnShown, whalesCanPrice, children }: {
  diamond: boolean;
  client: OddsLiveClient;
  columnShown: boolean;
  whalesCanPrice: boolean;
  children: ReactNode;
}) {
  const { unlock, upsell } = useWhalesUpsell(whalesCanPrice);
  const gate = useMemo<WhalesGate>(() => (diamond ? { kind: "unlocked", client } : { kind: "locked", unlock }), [diamond, client, unlock]);
  return (
    <WhalesGateContext.Provider value={gate}>
      <WhalesColumnShown.Provider value={columnShown && diamond}>
        {children}
        {!diamond && upsell}
      </WhalesColumnShown.Provider>
    </WhalesGateContext.Provider>
  );
}
